<template>
   <div class="bg-secondary text-light cc-style">
      <div class="row">
         <div class="col-10">
            <h5 class="ms-2">Control CRUD</h5>
         </div>
         <button class="btn btn-sm btn-dark col-1"
               type="button" 
               @click="changeOrderBy()"
         >
            Orden
         </button>
         <button class="btn btn-sm btn-dark col-1"
               type="button" 
               @click="addNew()"
         >
            Nuevo
         </button>
               <!-- 
         <div class="col-1">
            <h5><b>+</b></h5>
         </div>
               data-bs-dismiss="modal"
               aria-label="Close"
               ref="btn_out_MdContent"
               -->
      </div>
      <ul class="list-group">
         <li   v-for="(control, index) in controls" :key="index"
               class="list-group-item list-group-item-action list-group-item-dark"
         >
            <div class="row">
               <div class="col-1">
                  {{control.id}}
               </div>
               <div  class="col-1"
                     @click="changeType(control.id)"
               >
                  <div v-if="control.type">
                     {{control.type}}
                  </div>
                  <div v-else>
                     --
                  </div>
               </div>
               <div  class="col-10"
                     @click="upName(control)"
               >
                  {{control.name}}
               </div>
            </div>
         </li>
      </ul>
   </div>
</template>

<script>
//import { ref, onMounted, watch, computed, nextTick } from 'vue';
import { ref, onMounted } from 'vue';

import WspService from "/src/modules/workSpace/workSpace.service"; //src\modules\workSpace\workSpace.service.js

export default {
   setup() {
      const controls = ref([])
      const byAsc = ref(false)

      onMounted(() => {
         byAsc.value = false
         getControls('desc')
      })

      function addNew() {
         upControl(0, 'ok', null)
      }

      function changeOrderBy() {
         byAsc.value = !byAsc.value
         getControlsBy()
      }

      function getControlsBy() {
         if (byAsc.value) {
            getControls('asc')
         } else {
            getControls('desc')
         }
      }

      function getControls(ascDesc) {
         WspService.getControls(ascDesc).then(
            (response) => {
               controls.value = response.data;
            },
            (error) => {
               console.log(error.status);
            }
         );
      }

      function changeType(id) {
         upControl(id, 'ok', null)
      }

      function upName(ctrol) {
         let upName = prompt('ID Control: ' + ctrol.id, ctrol.name)
         if (upName != null) {
            upControl(ctrol.id, null, upName)
         }
      }

      function upControl(id, type, name) {
         WspService.upControl(id, type, name)
         .then(
            () => { getControlsBy() }
         )
         .catch(error => {
            console.log(error);
         });
      }

      return {
         controls,
         changeOrderBy,
         changeType,
         addNew,
         upName
      }
   },
}
</script>

<style scoped>
.cc-style {
   height: auto;
}
</style>
